<style lang="scss">




@media screen and (min-width: 55rem) {
  .schoolprocess-container {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .schoolprocess {
      max-width: 1080px;
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;
      height: 25rem;

      .schoolprocess-top {
        width: 100%;
        height: 10rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .schoolprocess-top-subtitle {
          font-size: 0.8rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .schoolprocess-top-title {
          font-size: 1.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
        }
        .schoolprocess-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .schoolprocess-list {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 80%;
        height: 10rem;
        // background-color: #e5004f;
        .schoolprocess-list-item {
          width: 6rem;
          height: 8rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .schoolprocess-icon {
            width: 4rem;
            height: 4rem;
            border-radius: 50%;
            background-image: url("/media/yintai/school-process-1.png");
            background-size: 50% 50%;
            background-position: center;
            background-color: #e5004f;
          }
          .schoolprocess-text {
            margin-top: 0.5rem;
            width: 6rem;
            height: 1rem;
            text-align: center;
            white-space: nowrap;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
          }
        }
        .schoolprocess-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: -3rem;
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .schoolprocess-container {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .schoolprocess {
      max-width: 1080px;
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .schoolprocess-top {
        width: 100%;
        height: 10rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .schoolprocess-top-subtitle {
          font-size: 0.8rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .schoolprocess-top-title {
          font-size: 1.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
        }
        .schoolprocess-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .schoolprocess-list {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;

        align-items: center;
        width: 100%;
        // background-color: #e5004f;
        .schoolprocess-list-item {
          width: 6rem;
          height: 8rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .schoolprocess-icon {
            width: 4rem;
            height: 4rem;
            border-radius: 50%;
            background-image: url("/media/yintai/school-process-1.png");
            background-size: 50% 50%;
            background-position: center;
            background-color: #e5004f;
          }
          .schoolprocess-text {
            margin-top: 0.5rem;
            width: 6rem;
            height: 1rem;
            text-align: center;
            white-space: nowrap;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
          }
        }
        .schoolprocess-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: -3rem;
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: "schoolprocess",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
